import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';

import { APOLLO_CLIENT_NAMES } from '@customer-portal/shared/constants';
import {
  apolloThrowIfNotSuccess,
  getQueryRootFieldName,
} from '@customer-portal/shared/helpers/custom-operators';

import { NotificationListDto } from '../../../dtos';
import {
  NOTIFICATIONS_DETAILS_QUERY,
  UPDATE_NOTIFICATION_READ_STATUS,
} from '../../../graphql';

@Injectable({
  providedIn: 'root',
})
export class NotificationListService {
  private clientName = APOLLO_CLIENT_NAMES.notification;

  constructor(private readonly apollo: Apollo) {}

  getNotificationList(): Observable<NotificationListDto> {
    const fieldName =
      getQueryRootFieldName(NOTIFICATIONS_DETAILS_QUERY) || 'notifications';

    return this.apollo
      .use(this.clientName)
      .query({
        query: NOTIFICATIONS_DETAILS_QUERY,
        fetchPolicy: 'no-cache',
      })
      .pipe(
        apolloThrowIfNotSuccess(fieldName),
        map((results: any) => results?.data?.notifications),
      );
  }

  updateNotification(id: number): Observable<boolean> {
    return this.apollo
      .use(this.clientName)
      .mutate({
        mutation: UPDATE_NOTIFICATION_READ_STATUS,
        variables: {
          noticationId: id,
        },
      })
      .pipe(
        map(
          (results: any) =>
            results?.data?.updateNotificationReadStatus?.data?.isSuccess ??
            false,
        ),
      );
  }
}
